import React, { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import COLOR from "utils/constants/color";

// Yellow bar animation
const mainBlock = keyframes`
  0% {
    width: 0%;
    left: 0;
  }
  50% {
    width: 100%;
    left: 0;
  }
  100% {
    width: 0%;
    left: 100%;
  }
`;

// Text fade-in animation (after yellow bar)
const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

// Styled Components

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 16px;
  width: 100%;
  @media (max-width: 768px) {
    padding-bottom: 30px;
  }
`;

const TextWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const TopBox = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 60px;
  background: #ffb510;
  width: 0%;
  display: flex;

  @media (max-width: 768px) {
    height: 50px;
  }

  ${({ animate }) =>
    animate &&
    css`
      animation: ${mainBlock} 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) forwards;
    `}
`;

const Text = styled.span`
  color: ${({ color }) => color || COLOR.black};
  font-size: ${({ size }) => size || "34px"};
  font-weight: 600;
  opacity: 0;
  ${({ animate }) =>
    animate &&
    css`
      animation: ${fadeIn} 1s ease-in forwards;
      animation-delay: 2s; /* wait for yellow bar */
    `}

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const AnimatedText = ({ text, page = "", textColor = "", fontSize = "" }) => {
  const [animateBar, setAnimateBar] = useState(false);
  const [animateText, setAnimateText] = useState(false);

  useEffect(() => {
    // Reset animations on text change
    setAnimateBar(false);
    setAnimateText(false);

    // Trigger yellow bar animation
    const barTimer = setTimeout(() => {
      setAnimateBar(true);
    }, 50);

    // Trigger text animation after yellow bar
    const textTimer = setTimeout(() => {
      setAnimateText(true);
    },150); // slightly after yellow bar finishes

    return () => {
      clearTimeout(barTimer);
      clearTimeout(textTimer);
    };
  }, [text]);

  return (
    <TextContainer className={page === "resource" ? "resource-container-text" : ""}>
      <TextWrapper>
        <TopBox animate={animateBar} />
        <Text
          color={textColor}
          size={fontSize}
          animate={animateText}
          className={page === "resource" ? "resource-animated-text" : ""}
        >
          {text}
        </Text>
      </TextWrapper>
    </TextContainer>
  );
};

export default AnimatedText;
